import { postCall, getCall, deleteCall, patchCall } from "../api";
import {
  loginUrl,
  transactionListUrl,
  userListUrl,
  bankListUrl,
  logoutUrl,
  counterUrl,
  deleteBankUrl,
  addBankUrl,
  editBankUrl,
  cityListUrl,
  editCityUrl,
  deleteCityUrl,
  stateListUrl,
  deleteStateUrl,
  countryListUrl,
  addCountryUrl,
  editCountryUrl,
  deleteCountryUrl,
  withdrawListUrl,
  recentTransactionListUrl,
  dashboardFundCounterUrl,
  dashboardStatisticsCounterUrl,
  reportAbuseListUrl,
  countryListAllUrl,
  addStateUrl,
  editStateUrl,
  stateListAllUrl,
  addCityUrl,
  accessLogListUrl,
  deleteReportAbuseUrl,
  editStatusUserUrl,
  transactionListExportUrl,
  userListExportUrl,
  commissionListUrl,
  editCommissionUrl,
} from "./apiList";
import {
  loginObj,
  addBankObj,
  editBankObj,
  addCountryObj,
  editCountryObj,
  editCityObj,
  addStateObj,
  editStateObj,
  addCityObj,
  editStatusUserObj,
  editCommissionObj,
} from "./apiObjects";

export function loginApi({ email, password, isWeb }) {
  return postCall(loginUrl(), loginObj({ email, password, isWeb }));
}

export function transactionListApi({ filterValues, queryParams }) {
  return getCall(transactionListUrl({ filterValues, queryParams }));
}

export function transactionListExportApi({ limit }) {
  return getCall(transactionListExportUrl({ limit }));
}

export function userListApi({ filterValues, queryParams }) {
  return getCall(userListUrl({ filterValues, queryParams }));
}

export function userListExportApi({ limit }) {
  return getCall(userListExportUrl({ limit }));
}

export function editStatusUserApi({ id, status }) {
  return patchCall(
    editStatusUserUrl({ id }),
    editStatusUserObj({
      status,
    })
  );
}

export function bankListApi({ filterValues, queryParams }) {
  return getCall(bankListUrl({ filterValues, queryParams }));
}

export function logoutApi({ id }) {
  return deleteCall(logoutUrl({ id }));
}

export function counterApi() {
  return getCall(counterUrl());
}

export function deleteBankApi({ id }) {
  return deleteCall(deleteBankUrl({ id }));
}

export function addBankApi({ bank_name, status }) {
  return postCall(addBankUrl(), addBankObj({ bank_name, status }));
}

export function editBankApi({ id, bank_name, status }) {
  return patchCall(
    editBankUrl({ id }),
    editBankObj({
      bank_name,
      status,
    })
  );
}

export function cityListApi({ filterValues, queryParams, isActiveOnly }) {
  return getCall(cityListUrl({ filterValues, queryParams, isActiveOnly }));
}

export function editCityApi({ id, name, status, state_id }) {
  return patchCall(
    editCityUrl({ id }),
    editCityObj({
      name,
      status,
      state_id,
    })
  );
}

export function deleteCityApi({ id }) {
  return deleteCall(deleteCityUrl({ id }));
}

export function addStateApi({ state_name, state_code, country_id, status }) {
  return postCall(
    addStateUrl(),
    addStateObj({ state_name, state_code, country_id, status })
  );
}

export function addCityApi({ name, state_id, status }) {
  return postCall(addCityUrl(), addCityObj({ name, state_id, status }));
}

export function editStateApi({
  id,
  state_name,
  state_code,
  country_id,
  status,
}) {
  return patchCall(
    editStateUrl({ id }),
    editStateObj({
      state_name,
      state_code,
      country_id,
      status,
    })
  );
}

export function stateListApi({ filterValues, queryParams, isActiveOnly }) {
  return getCall(stateListUrl({ filterValues, queryParams, isActiveOnly }));
}

export function stateListAllApi({ isActiveOnly }) {
  return getCall(stateListAllUrl({ isActiveOnly }));
}

export function deleteStateApi({ id }) {
  return deleteCall(deleteStateUrl({ id }));
}

export function countryListApi({ filterValues, queryParams, isActiveOnly }) {
  return getCall(countryListUrl({ filterValues, queryParams, isActiveOnly }));
}

export function countryListAllApi({ isActiveOnly }) {
  return getCall(countryListAllUrl({ isActiveOnly }));
}

export function addCountryApi({ name, country_code, status }) {
  return postCall(
    addCountryUrl(),
    addCountryObj({ name, country_code, status })
  );
}

export function editCountryApi({ id, name, country_code, status }) {
  return patchCall(
    editCountryUrl({ id }),
    editCountryObj({
      name,
      country_code,
      status,
    })
  );
}

export function deleteCountryApi({ id }) {
  return deleteCall(deleteCountryUrl({ id }));
}

export function withdrawListApi({ currentPage, filterValues, queryParams }) {
  return getCall(withdrawListUrl({ currentPage, filterValues, queryParams }));
}

export function recentTransactionListApi(selectedTab) {
  return getCall(recentTransactionListUrl(selectedTab));
}

export function dashboardFundCounterApi() {
  return getCall(dashboardFundCounterUrl());
}

export function dashboardStatisticsCounterApi() {
  return getCall(dashboardStatisticsCounterUrl());
}

export function reportAbuseListApi({ filterValues, queryParams }) {
  return getCall(reportAbuseListUrl({ filterValues, queryParams }));
}

export function accessLogListApi({ filterValues, queryParams }) {
  return getCall(accessLogListUrl({ filterValues, queryParams }));
}

export function deleteReportAbuseApi({ id }) {
  return deleteCall(deleteReportAbuseUrl({ id }));
}

export function commissionListApi({}) {
  return getCall(commissionListUrl({}));
}

export function editCommissionApi({ data }) {
  return patchCall(
    editCommissionUrl(),
    editCommissionObj({
      data,
    })
  );
}
